import SuccessDomainRegister from "components/SuccessDomain/SuccessDomainRegister";
import { useQuery } from "helpers/utils";
import {
  search,
  searchDomainName,
} from "features/domain/domainsSlice";
import { useEffect, useRef, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
// import custom from "../../../assets/scss/Domain.module.scss"; // File sudah dihapus
import {
  searchDomains,
} from "features/domain/domainsSlice";
import { notifyWarning, notifyError } from "components/ToastMessage";

const validateDomain = (domainInput, extensionTransfer, setDisableRegister) => {
  const kamus = [
    "togel",
    "judi",
    "sex",
    "porn",
    "bugil",
    "bokep",
    "xxx",
    "kontol",
    "casino",
    "kasino",
  ];

  const whitelist = [
    "camillajava",
    "javaleap",
    "unigoldtechnology",
    "livelifebetter",
    "sirajudinhasbi",
    "javapustaka",
    "lajudigital",
    "westjava-shizuoka",
    "betariko",
    "tipjavatransport",
  ];

  const validateSingleDomain = (domainName) => {
    const badWord = kamus.some((str) => domainName.includes(str));
    const whiteWord = whitelist.some((str) => domainName.includes(str));

    if (badWord && !whiteWord) {
      notifyWarning("Domain Anda mengandung kata terlarang!");
      setDisableRegister(false);
      return false;
    }

    if (domainName.length < 2) {
      notifyWarning("Nama domain minimal 2 karakter!");
      setDisableRegister(false);
      return false;
    }

    if (!domainName) {
      notifyWarning("Domain Anda kosong!");
      setDisableRegister(false);
      return false;
    }

    if (!extensionTransfer) {
      notifyWarning("Ekstensi Anda kosong!");
      setDisableRegister(false);
      return false;
    }

    if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(domainName)) {
      notifyWarning("Domain Anda tidak valid!");
      setDisableRegister(false);
      return false;
    }

    return true;
  };

  if (Array.isArray(domainInput)) {
    return domainInput.every((domain) => validateSingleDomain(domain));
  } else {
    return validateSingleDomain(domainInput);
  }
};

const RegisterDomain = forwardRef((props, ref) => {
  const { registrationType, setRegistrationType, domainMethod, setDomainMethod, onToggleDomainSections } = props;
  const { status } = useSelector((state) => state.domain);
  const { noDomain } = useSelector((state) => state.hosting);
  const query = useQuery();
  const dispatch = useDispatch();
  const tldRef = useRef();
  const domainRegister = query.domainregister;

  const [extension, setExtension] = useState("");
  const [price, setPrice] = useState([]);
  const [domain, setDomain] = useState("");
  const [disableRegister, setDisableRegister] = useState(false);
  const [isAutoFocus, setIsAutoFocus] = useState(false);
  const [isAutoFocusMultiple, setIsAutoFocusMultiple] = useState(false);
  const [multipleDomains, setMultipleDomains] = useState("");
  const [promoDomains, setPromoDomains] = useState([]);
  const [extOption, setExtOption] = useState([]);

  let notifyTimeout;

  // Fetch domain extensions
  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((response) => response.json())
      .then((val) => setExtOption(val))
      .catch((error) => {
        console.error('Error fetching domain extensions:', error);
        setExtOption([]);
      });
  }, []);

  // Function to handle domain sections toggle
  const handleToggleDomainSections = (shouldShow) => {
    if (onToggleDomainSections && typeof onToggleDomainSections === 'function') {
      onToggleDomainSections(shouldShow);
      
      // If showing sections, focus on the domain input after a short delay
      if (shouldShow) {
        setTimeout(() => {
          const domainInput = document.getElementById("searchDomain");
          if (domainInput) {
            domainInput.focus();
            domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      }
    }
  };

  useEffect(() => {
    if (domainRegister) {
      const domainArr = domainRegister
        .split(",")
        .map((domain) => domain.trim());
      const extDomainArr = domainArr.map((domain) => domain.split(".")[1]);

      const isValid = validateDomain(domainArr, extDomainArr, setDisableRegister);
      if (!isValid) return;

      if (domainArr.length > 1) {
        setRegistrationType("multiple");
      } else {
        setRegistrationType("single");
      }

      domainArr.forEach(domain => checkDomainPromo(domain));

      dispatch(searchDomains(domainArr));
    }
  }, [domainRegister, dispatch, setRegistrationType]);

  const searchDomain = (e) => {
    e.preventDefault();

    const isValid = validateDomain(domain, extension, setDisableRegister);
    if (!isValid) return;

    const domainWithExtension = domain + extension;

    // Check for .id extension and billing cycle annually
    if (extension === ".id") {
      checkDomainPromo(domainWithExtension);
    }

    dispatch(search({ domain, extension, price }));
    dispatch(searchDomainName(domainWithExtension));

    setDisableRegister(true);
  };

  const options = (extOption || []).map(function (option) {
    // Handle both old and new API response formats
    if (Array.isArray(option) && option.length >= 5) {
      // New format: [id, extension, category, price1, price2, description, requirements, expiry]
      return { 
        value: option[1], // Extension (.abogado)
        label: option[1], // Extension (.abogado)
        price: option[3]  // Price (473000)
      };
    } else if (typeof option === 'object' && option.extension) {
      // Old format: {extension: ".com", price: "100000"}
      return { 
        value: option.extension, 
        label: option.extension, 
        price: option.price 
      };
    } else {
      // Fallback for unexpected format
      console.warn('Unexpected domain extension format:', option);
      return { value: '', label: '', price: '0' };
    }
  }).filter(option => option.value && option.value !== ''); // Filter out empty options

  const handleExtension = (e) => {
    if (!e) {
      setExtension("");
      return;
    }
    setExtension(e.value);
    setPrice(e.price);
  };

  const setDomainHandler = (e) => {
    const { value } = e.target;
    // Remove special characters including period and comma using regex
    const domainWithoutSpecialChars = value.replace(/[.,]/g, "");
    setDomain(domainWithoutSpecialChars);

    // Check if dot button is pressed
    if (value.endsWith(".") && tldRef.current) {
      tldRef.current.focus();
    }
  };

  const setDomainHandlerMultiple = (e) => {
    const { value } = e.target;
    const domainWithCommas = value.replace(/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/g, "");
    setMultipleDomains(domainWithCommas);

    // Split domains and trim spaces
    const domains = domainWithCommas.split(',').map(d => d.trim());

    // Check for trailing comma without a domain
    if (domains[domains.length - 1] === "") {
      notifyWarning("Domain tidak boleh diakhiri dengan koma tanpa domain berikutnya!");
      return;
    }

    const validDomains = domains.filter(d => d.length > 0);

    for (let domain of validDomains) {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;

      const selectedOption = options.find(option => option.value === extension);
      if (selectedOption) {
        setPrice(selectedOption.price);
      }
    }
  };

  useEffect(() => {
    if (status !== "loading") {
      setDisableRegister(false);
    }
  }, [status]);

  useEffect(() => {
    if (query.extension) {
      fetch(
        `${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domainregister&extension=` +
          query.extension
      )
        .then((data) => data.json())
        .then((val) => {
          let price = parseFloat(val.data[0].msetupfee);
          setExtension(query.extension);
          setPrice(String(price));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [query.extension]);

  useEffect(() => {
    if (noDomain) {
      setTimeout(() => {
        if (registrationType === "single") {
          setIsAutoFocus(true);
          if (ref.current) {
            ref.current.focus();
          }
        } else {
          setIsAutoFocusMultiple(true);
          if (ref.current) {
            ref.current.focus();
          }
        }
      }, 500);
    }
  }, [noDomain, ref, registrationType]);

  const checkDomainPromo = async (domain) => {
    try {
      // Skip check if domain is empty or invalid
      if (!domain || typeof domain !== 'string') {
        return;
      }

      // Only check for .id domains
      if (!domain.endsWith('.id')) {
        return;
      }

      // Create AbortController for timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 seconds timeout

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}order/apis/checkDomainPromo.php?domain=${encodeURIComponent(domain)}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            signal: controller.signal,
          }
        );

        clearTimeout(timeoutId);

        if (!response.ok) {
          // Don't throw error, just return silently
          return;
        }

        const data = await response.json();
        if (data && data.code === 200 && domain.endsWith('.id')) {
          // Only add if not already in the list
          setPromoDomains((prev) => {
            if (!prev.includes(domain)) {
              return [...prev, domain];
            }
            return prev;
          });
        }
      } catch (fetchError) {
        clearTimeout(timeoutId);
        // Re-throw to outer catch if it's not an abort error
        if (fetchError.name !== 'AbortError') {
          throw fetchError;
        }
      }
    } catch (error) {
      // Silently handle errors - don't log network errors to avoid console noise
      // Network errors (Failed to fetch) are expected if API doesn't exist or is unreachable
      if (error.name !== 'AbortError' && error.name !== 'TypeError' && !error.message?.includes('fetch')) {
        console.warn("Error checking promo domain:", error.message);
      }
      // Don't throw or re-throw the error - fail silently
    }
  };

  const searchMultipleDomains = (e) => {
    e.preventDefault();
    const domains = multipleDomains.split(',').map(d => d.trim());

    // Check for trailing comma without a domain
    if (domains[domains.length - 1] === "") {
      if (!notifyTimeout) {
        notifyWarning("Domain tidak boleh diakhiri dengan koma tanpa domain berikutnya!");
        notifyTimeout = setTimeout(() => {
          notifyTimeout = null;
        }, 10000); // 10 seconds
      }
      return;
    }

    const validDomains = domains.filter(d => d.length > 0);

    if (validDomains.length === 0) {
      notifyWarning("Domain Anda kosong!");
      return;
    }

    const validExtensions = options.map(option => option.value);
    const invalidDomains = validDomains.filter(domain => {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;
      return !validExtensions.includes(extension);
    });

    if (invalidDomains.length > 0) {
      notifyError(`Maaf, Domain ini memiliki ekstensi tidak valid: ${invalidDomains.join(', ')}`);
      return;
    }

    // Validate each domain
    const allValid = validDomains.every(domain => validateDomain(domain, domain.split('.').pop(), setDisableRegister));
    if (!allValid) return;

    // Check for .id extension and billing cycle annually
    for (const domain of validDomains) {
      const parts = domain.split('.');
      const extension = `.${parts[parts.length - 1]}`;
      if (extension === ".id") {
        checkDomainPromo(domain);
      }
    }

    dispatch(searchDomains(validDomains));
    setDisableRegister(true);
  };

  const handleRegistrationTypeChange = (e) => {
    const value = e.target.value;
    setRegistrationType(value);
    setDomainMethod("register");
  };


    return (
    <div className="card mb-3 shadow-sm" style={{ minHeight: "100px", borderRadius: "16px", borderColor: "transparent" }}>
      {/* Daftar Domain Baru */}
      <div className="card-body">
        <div className="form-check py-1 px-4">
          <input
            type="radio"
            className="form-check-input"
            name="domainMethod"
            id="daftarDomain1"
            value="single"
            checked={registrationType === "single" && domainMethod === "register"}
            onChange={handleRegistrationTypeChange}
          />
          <label
            htmlFor="daftarDomain1"
            className="form-check-label fw-bold"
            style={{ fontSize: "18px", marginLeft: "20px" }}
          >
            Daftar Domain
          </label>
          <p className="mb-0 mt-2" style={{ marginLeft: "21px", marginTop: "6px" }}>
            Miliki ekstensi Domain terbaik untuk identitas website & bisnis di internet
          </p>

          {registrationType === "single" && domainMethod === "register" && !query.domainregister && (
            <form onSubmit={searchDomain} className="mt-3">
              <div className="row g-3">
                <div className="col-12 col-md-5">
                  <input
                    id="searchDomain"
                    type="text"
                    ref={ref}
                    className="form-control"
                    placeholder="Nama Domain Anda"
                    onChange={(e) => setDomainHandler(e)}
                    value={domain}
                    autoFocus={isAutoFocus}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    onChange={handleExtension}
                    isSearchable={true}
                    name="extensions"
                    options={options}
                    placeholder="Pilih ekstensi..."
                    defaultValue={query.extension ? { value: query.extension, label: query.extension } : ""}
                    noOptionsMessage={() => "Tidak ada ekstensi tersedia"}
                    loadingMessage={() => "Memuat ekstensi..."}
                    isLoading={extOption.length === 0}
                    isDisabled={extOption.length === 0}
                    menuPlacement="auto"
                    menuPosition="fixed"
                    maxMenuHeight={200}
                    filterOption={(option, inputValue) => {
                      if (!inputValue) return true;
                      const label = option.label || option.value || '';
                      return label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                    formatOptionLabel={(option) => {
                      return <span>{option.label}</span>;
                    }}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-cta w-100 rounded-5"
                    type="submit"
                    disabled={disableRegister}
                  >
                    Cek Domain
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* Pesan Banyak Domain */}
      <div className="card-body">
        <div className="form-check mb-3 py-1 px-4">
          <input
            type="radio"
            className="form-check-input"
            name="domainMethod"
            id="daftarDomain2"
            value="multiple"
            checked={registrationType === "multiple" && domainMethod === "register"}
            onChange={handleRegistrationTypeChange}
          />
          <label
            htmlFor="daftarDomain2"
            className="form-check-label fw-bold"
            style={{ fontSize: "18px", marginLeft: "20px" }}
          >
            Pesan Banyak Domain Baru
          </label>
          <p className="mb-0 mt-2" style={{ marginLeft: "21px", marginTop: "6px" }}>
            Pesan banyak Domain terbaik dengan ekstensi berbeda
          </p>

          {registrationType === "multiple" && domainMethod === "register" && (
            <form onSubmit={searchMultipleDomains} className="mt-3">
              <div className="row g-3">
                <div className="col-12 col-md-9">
                  <input
                    id="searchMultipleDomain"
                    type="text"
                    ref={ref}
                    className="form-control"
                    placeholder="qwords1.id, qwords2.com, ... (Pisahkan dengan koma)"
                    onChange={(e) => setDomainHandlerMultiple(e)}
                    value={multipleDomains}
                    autoFocus={isAutoFocusMultiple}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-cta w-100 rounded-5"
                    type="submit"
                    disabled={disableRegister}
                  >
                    Cek Domain
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* Success Message Component */}
      {(domainRegister || domainMethod === "register") && (
        <SuccessDomainRegister 
          extensions={extOption} 
          mode={registrationType} 
          promoDomains={promoDomains}
          onToggleDomainSections={handleToggleDomainSections}
        />
      )}
    </div>
  );
});

export default RegisterDomain;
